import React from 'react';
import cn from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { string, func, number, oneOfType, oneOf, shape, node } from 'prop-types';
import Icon from '../Icon/Icon';
import { isNil } from '../../utils/utils';

const propTypes = {
  id: string.isRequired,
  text: node.isRequired,
  className: string,
  delay: oneOfType([shape({ show: number, hide: number }), number]),
  children: node,
  tag: oneOfType([func, string]),
  icon: string,
  placement: oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
};

const defaultProps = {
  text: '',
  placement: 'top',
  tag: 'span',
  icon: 'info',
};

const Tooltip = ({ id, placement, text, delay, className, children, tag: Tag, icon }) => (
  <Tag className={cn('custom-tooltip', className)}>
    <Icon id={id} type={icon} />

    <UncontrolledTooltip placement={placement} delay={delay} target={id}>
      {isNil(children) ? text : children}
    </UncontrolledTooltip>
  </Tag>
);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;
